export enum Languages {
    RU = 'ru',
    EN = 'en',
    KK = 'kk',
    QQ = 'qq',
}

export const enum Types {
    SECTION = 'section',
    CATEGORY = 'category',
    ARTICLE = 'article',
    TAG = 'tag',
}

export type ArticleRelations = {
    relations: {
        section: string;
        category: string;
        tag: string;
    };
};

export interface ArticleInfo {
    label: string;
    value: string;
}

export type SharedFields = {
    id: string;
    path: string;
    type: Types;
    title: string;
    parent?: string;
};

export type Tag = SharedFields & { icon: string };
export type Section = SharedFields;
export type Category = SharedFields;
export type NoContentArticle = SharedFields & { tagId: string };

export type FullArticle = SharedFields & {
    content: string;
    rating: number;
    scores: number;
    tagId: string;
    linked?: ArticleInfo[];
    views: number;
    updatedAt: string;
};

export type SearchResult = Omit<FullArticle, 'rating' | 'scores' | 'linked'>;

export type KBEntity = Section | Category | FullArticle | NoContentArticle | Tag;
